import Texts from './Texts';

export default Texts;
